import { gsap } from 'gsap';

class AccordionEntry {
	constructor(el) {
		// DOM elements
		this.el = el;
		this.button = el.querySelector('[data-accordion-target]');
		this.target = el.querySelector(this.button.dataset.accordionTarget);

		// Status
		this.isOpen = false;
		this.isAnimating = false;

		// Event listeners
		this.button.addEventListener('click', this.toggle.bind(this));
		this.events = [];
	}

	toggle() {
		if (this.isAnimating) {
			return;
		}

		this.isOpen ? this.close() : this.open();
	}

	open() {
		if (this.isOpen) {
			return;
		}

		this.isAnimating = true;

		this.el.classList.add('is-open');
		this.button.classList.add('is-active');

		this.dispatch('open');

		return new Promise((resolve) => {
			const item = this.target;
			const height = item.scrollHeight;

			gsap.set(item, {
				opacity: 0,
			});

			const tl = gsap.timeline({
				onComplete: () => {
					gsap.set(item, {
						height: 'auto',
					});

					this.isOpen = true;
					this.isAnimating = false;
					resolve();
				},
			});

			tl.to(item, {
				height: height,
				duration: 0.15,
				ease: 'none',
			});
			tl.to(item, {
				opacity: 1,
				duration: 0.3,
				ease: 'none',
			});
		});
	}

	close() {
		if (!this.isOpen) {
			return;
		}

		this.isAnimating = true;

		this.el.classList.remove('is-open');
		this.button.classList.remove('is-active');

		this.dispatch('close');

		return new Promise((resolve) => {
			const item = this.target;

			gsap.set(item, {
				height: item.scrollHeight,
			});

			const tl = gsap.timeline({
				onComplete: () => {
					gsap.set(item, {
						height: 0,
					});

					this.isOpen = false;
					this.isAnimating = false;

					resolve();
				},
			});

			tl.to(item, {
				opacity: 0,
				duration: 0.3,
				ease: 'none',
			});
			tl.to(item, {
				targets: item,
				height: 0,
				duration: 0.15,
				ease: 'none',
			});
		});
	}

	// Register events
	on(eventName, callback) {
		this.events.push({
			eventName,
			callback,
		});
	}

	dispatch(eventName) {
		const eventObjects = this.events.filter((event) => event.eventName === eventName);

		if (!eventObjects) {
			return;
		}

		eventObjects.forEach((eventObject) => {
			eventObject.callback(this);
		});
	}
}

export default class Accordion {
	constructor(el) {
		this.entries = el.querySelectorAll('[data-accordion-parent');
		this.accordionEntries = new Map();

		this.entries.forEach((entry) => {
			const accordionEntry = new AccordionEntry(entry);

			// When opening an entry, close other accordion entries
			accordionEntry.on('open', (entry) => {
				this.accordionEntries.forEach((instance, instanceEl) => {
					if (entry.el !== instanceEl) {
						instance.close();
					}
				});
			});

			this.accordionEntries.set(entry, accordionEntry);
		});
	}
}
